/*  React  */
import React from 'react';
import { useTranslation } from 'react-i18next';

/*  Components  */
import { QBRManagedTable } from './QBRManagedTable';
import { QBRPieChart } from './QBRPieChart';
import { QBRReportHeader } from './QBRReportHeader';
import { QBRScoreHistoryAndInsights } from './QBRScoreHistoryAndInsights';

export const QBRFirstShadowItScore = (props) => {
    const { t } = useTranslation();
    const { reportData, renderingScheduledReport } = props;

    const reportType = 'ShadowITScore';

    const stages = Object.entries(reportData.data).map(([key, value]) => ({
        name: t(`Common.${key}`),
        value
    }));

    return (
        <>
            <QBRReportHeader {...{ ...props, reportType }} />
            <QBRScoreHistoryAndInsights
                reportType={reportType}
                props={{ ...props }}
            />
            <QBRPieChart
                data={stages}
                renderingScheduledReport={renderingScheduledReport}
                showPopover={false}
                title={t('QBR.applicationClassificationStatus')}
            />
            <hr />
            <QBRManagedTable
                rows={reportData.topUnclassified}
                rowsPerPage={-1}
                title={t('QBR.top10UnClassifiedApplicationsByUsage')}
            />
        </>
    );
};
